"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageGrid = void 0;
var tslib_1 = require("tslib");
var pdfTheme_1 = require("../pdfTheme");
var ImageWithTitle_1 = require("./ImageWithTitle");
var COLUMN_SPACING = pdfTheme_1.pdfTheme.spacing.default;
var ImageGrid = /** @class */ (function () {
    function ImageGrid(imageGroups, columns, availableWidth) {
        if (columns === void 0) { columns = 3; }
        if (availableWidth === void 0) { availableWidth = pdfTheme_1.pdfTheme.page.width; }
        this.imageGroups = imageGroups;
        this.columns = columns;
        this.availableWidth = availableWidth;
        this.nodes = [];
    }
    ImageGrid.prototype.exportContent = function () {
        var _this = this;
        var rows = [];
        var imageWidth = (this.availableWidth - (COLUMN_SPACING * (this.columns - 1))) / this.columns;
        Object.entries(this.imageGroups).sort(function (a, b) { return a[0].localeCompare(b[0]); }).forEach(function (_a) {
            var group = _a[0], imageReferences = _a[1];
            imageReferences.forEach(function (imageReference, i) {
                var image = new ImageWithTitle_1.ImageWithTitle(group, imageReference, { pageBreak: 'none', width: imageWidth });
                _this.nodes.push(image);
            });
        });
        this.nodes.forEach(function (node, i) {
            var _a;
            if (i % _this.columns === 0) {
                rows.push([]);
            }
            var content = node.exportContent();
            content.width = (100 / _this.columns) + '%';
            (_a = rows[rows.length - 1]) === null || _a === void 0 ? void 0 : _a.push(content);
        });
        return {
            marginTop: 2,
            marginBottom: 2,
            stack: tslib_1.__spreadArray([], rows.map(function (columnSet) { return ({
                columns: columnSet,
                columnGap: COLUMN_SPACING,
                marginBottom: 10
            }); }), true)
        };
    };
    ImageGrid.prototype.exportStyles = function () {
        return {
            imageGridTitle: {
                fontSize: 15,
                bold: true,
                marginBottom: 6
            }
        };
    };
    return ImageGrid;
}());
exports.ImageGrid = ImageGrid;
//# sourceMappingURL=ImageGrid.js.map